import * as helpers from './helpers.js';
import * as shopify from './shopify.js';
import * as state from './state.js';

async function init() {
  if (!shopify.isOnCart() || shopify.isOnCheckout()) {
    // console.log('not on cart');
    return;
  }


  const currentCart = shopify.getCurrencyFromCartUrl();
  let cartState = state.getCartState();

  // console.log('cart state from cookie');
  // console.log(cartState);

  if (cartState === null || currentCart === cartState.lastCart) {
    // first time on the cart ever, or
    // we haven't switched carts;
    // either way, we should save the current cart state.

    // console.log( 'first time, or same cart; updating...' );


    const skuQtys = await getCartSkuQuantities();
    // console.log(skuQtys);
    cartState = {
      lastCart: currentCart,
      'skuQtys': skuQtys,
    };

    state.setCartState(cartState);

  } else {
    // we have switched carts!

    // it is slightly possible that this cart already has an item in it
    // if we added items to last cart, then changed country on www, then clicked
    // buy button, directing us to this new cart.

    // if there is anything in this cart, we'll want to add it to what we had in
    // the previous cart. ignore the above.  Not worth it given the wierd
    // experiences it can also add.

    // console.log('new cart!');

    // let newCartSkuQtys = await getCartSkuQuantities();
    let lastCartKeysQty = cartState.skuQtys;

    // console.log('qtys from this new cart:');
    // console.log(newCartSkuQtys);

    // console.log('qtys from last cart:');
    // console.log(lastCartKeysQty);

    // lastCartKeysQty is the priority.
    // however, if there is a single QTY 1 SKU in this new cart,
    // it means we changed languages on www, and then clicked 'buy'.
    // we should add that new item to our cart.

    // ignore the above. To limit the wierd cases, we'll just ignore the
    // contents of the current cart.

    /*
    let singleItemSku = getSingleQtySkuOrNull(newCartSkuQtys);
    if(singleItemSku !== null ){
        // console.log( `single item sku ${singleItemSku}`);
        lastCartKeysQty[singleItemSku]++;
        // console.log(lastCartKeysQty);
    }
    */

    let result = await updateCartSkuQuantities(lastCartKeysQty);

    if (result) {
      const newState = {
        lastCart: currentCart,
        'skuQtys': lastCartKeysQty,
      };

      // console.log(newState);
      state.setCartState(newState);

      // need to refresh to show the new cart contents to the user
      window.location.reload();

    } else {
      console.log('updateCartSkuQuantities failed');
    }
  }
}

async function getCartSkuQuantities() {
  const request = {
    method: 'GET',
    credentials: 'same-origin',  // use cookies, needed by shopify
    headers: {
      'Content-Type': 'application/json',
    },
  };

  // obtains items in the current cart
  let response = await fetch('/cart.js', request);
  let json = await response.json();

  // console.log(json);

  // json has 'items' array, with variant_id and quantity;

  let skuQtys = {};

  // first, specify what we don't have, so we can clear those out just in case.
  const skus = shopify.getSkuList();
  // console.log(skus);
  skus.forEach((sku) => {
    skuQtys[sku] = 0;
  });

  json.items.forEach((item) => {
    let sku = shopify.getSkuByVariant(item.variant_id);

    // if for whatever reason this variant isn't in our product constants, don't
    // try to save it.
    if (sku === null) return;

    let qty = item.quantity;
    skuQtys[sku] = qty;
  });

  return skuQtys;
}

async function updateCartSkuQuantities(skuQtys) {
  // now we want variant quantities...
  let variantQtys = {};
  for (let sku in skuQtys) {
    let variant = shopify.getVariantBySku(sku);

    // if the SKU is not available in this store, just don't add it.
    if (variant === null) continue;

    let quantity = skuQtys[sku];
    variantQtys[variant] = quantity;
  }

  let updates = {
    'updates': variantQtys,
  }

  const request = {
    body: JSON.stringify(updates),
    method: 'POST',
    credentials: 'same-origin',  // use cookies, needed by shopify
    headers: {
      'Content-Type': 'application/json',
    },
  };

  let response = await fetch('/cart/update.js', request);
  if (!response.ok)  // fetch does not throw on 404
    return null;

  let json = await response.json();
  return json;
}

/*
function getSingleQtySkuOrNull(skuQtys){

    let qtyOneSku = null;
    for( let sku in skuQtys ){
        if( skuQtys[sku] > 1 )
            return null; // not single qty

        if( skuQtys[sku] == 1 ){  //ignore type here
            if( qtyOneSku === null ){
                qtyOneSku = sku;
            }else{
                return  null;
            }
        }
    }
    return qtyOneSku;
}
*/

export {
  init,
};
